// *https://www.registers.service.gov.uk/registers/country/use-the-api*
//import fetch from "cross-fetch";

import React, {useState, useEffect, Fragment} from 'react';
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import CircularProgress from "@material-ui/core/CircularProgress";
import Service from "../services/Service";
import {Formik,useFormikContext, Form, Field} from  'formik';
import debounce from 'lodash.debounce';
import {formattingMoney} from "./utils/formatting";


function sleep(delay = 0) {
    return new Promise((resolve) => {
        setTimeout(resolve, delay);
    });
}

export default function Asynchronous(props) {
    const [open, setOpen] = useState(false);
    const [options, setOptions] = useState([]);
    const loading = open && options.length === 0;
    //const [inputValue, setInputValue] = useState('');

    const search = (inputValue) => {
        let active = true;
        if (!inputValue){
            active = false;
            return false;
        }
        (async () => {
            const service = new Service();
            service.searchSecurity({
                "s": inputValue
            }).then(
                function (response) {
                    if (active) {
                        // setOptions(Object.keys(response).map((id) => response[id].item[0].name));
                        setOptions(response.data);
                        console.log(options)
                    }
                }

            )
        })()
        // if (!loading) {
        //     return undefined;
        // }

        return () => {
            active = false;
        };
    }
    const timeout_search =debounce(search, 500)
    // useEffect(() => {
    //
    // }, [inputValue]);

    useEffect(() => {
        if (!open) {
            setOptions([]);
        }
    }, [open]);
    // const formikProps = useFormikContext()
    // const someFunctionWithLogic = (value, setFieldValue) => {
    //     // Set the value of the number field here...
    //     setFieldValue('security', value)
    // }
    const {action} = props
    return (
        <Autocomplete
            id="security"
            name="security"
            fullWidth
            style={{ marginBottom: 10 }}
            open={open}
            onOpen={() => {
                setOpen(true);
            }}
            onClose={() => {
                setOpen(false);
            }}
            onInputChange={(event, newInputValue) => {
                //setInputValue(newInputValue)
                timeout_search(newInputValue)
                //search(newInputValue)
            }}
            onChange={ (e, value) => action(value)}
            //getOptionSelected={(option, value) => option.id === value.id}
            getOptionLabel={(option) => option.ticker+' - '+option.name}
            options={options}
            filterOptions={(x) => x}
            renderOption={(option) => (
                <Fragment>
                    {option.ticker} - {option.name}
                </Fragment>
            )}
            loading={loading}
            renderInput={(params) => (
                <TextField
                    {...params}
                    label="Бумага/компания"
                    InputLabelProps={{shrink: true}}
                    placeholder="Начните вводить тикер/isin или название компании"
                    variant="outlined"
                    InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                            <Fragment>
                                {loading ? (
                                    <CircularProgress color="inherit" size={20} />
                                ) : null}
                                {params.InputProps.endAdornment}
                            </Fragment>
                        )
                    }}
                />
            )}
        />
    );
}
